export const environment = {
    production: false,
    apiUrl: 'https://api.sport.masak.qual.cawita.com',
    assetUrl: 'https://assets.sport.masak.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};
